export enum LanguageEnum { //never change order
  DEUTSCH,
  ENGLISCH,
  ITALIENISCH,
  FRANZÖSISCH,
  AFRIKAANS,
  ALBANISCH,
  AMHARISCH,
  ARABISCH,
  ARMENISCH,
  ASERBAIDSCHANISCH,
  BASKISCH,
  BENGALISCH,
  BIRMANISCH,
  BOSNISCH,
  BULGARISCH,
  CEBUANO,
  CHINESISCH_TRADITIONELL,
  CHINESISCH_VEREINFACHT,
  DÄNISCH,
  ESPERANTO,
  ESTNISCH,
  FILIPINO,
  FINNISCH,
  GALICISCH,
  GEORGISCH,
  GRIECHISCH,
  GUJARATI,
  HAITI_KREOLISCH,
  HAUSSA,
  HAWAIISCH,
  HEBRÄISCH,
  HINDI,
  HMONG,
  IGBO,
  INDONESISCH,
  IRISCH,
  ISLÄNDISCH,
  JAPANISCH,
  JAVANISCH,
  JIDDISCH,
  KANNADA,
  KASACHISCH,
  KATALANISCH,
  KHMER,
  KIRGISISCH,
  KOREANISCH,
  KORSISCH,
  KROATISCH,
  KURDISCH,
  LAOTISCH,
  LATEIN,
  LETTISCH,
  LITAUISCH,
  LUXEMBURGISCH,
  MADAGASSISCH,
  MALAIISCH,
  MALAYALAM,
  MALTESISCH,
  MAORI,
  MARATHI,
  MAZEDONISCH,
  MONGOLISCH,
  NEPALESISCH,
  NIEDERLÄNDISCH,
  NORWEGISCH,
  NYANJA,
  PASCHTU,
  PERSISCH,
  POLNISCH,
  PORTUGIESISCH,
  PUNJABI,
  RUMÄNISCH,
  RUSSISCH,
  SAMOANISCH,
  SCHOTTISCHES_GÄLISCH,
  SCHWEDISCH,
  SERBISCH,
  SHONA,
  SINDHI,
  SINGHALESISCH,
  SLOWAKISCH,
  SLOWENISCH,
  SOMALI,
  SPANISCH,
  SUAHELI,
  SÜD_SOTHO,
  SUNDANESISCH,
  TADSCHIKISCH,
  TAMIL,
  TELUGU,
  THAILÄNDISCH,
  TSCHECHISCH,
  TÜRKISCH,
  UKRAINISCH,
  UNGARISCH,
  URDU,
  USBEKISCH,
  VIETNAMESISCH,
  WALISISCH,
  WEISSRUSSISCH,
  WESTFRIESISCH,
  XHOSA,
  YORUBA,
  ZULU,
  PHILIPPINISCH,
}
